import React from "react";
import {useTranslation} from "react-i18next";
import {useStore} from "../../../../../hooks/useStore";
import {SelectField} from "./CompanyInput.styles";
import {useObserver} from "mobx-react-lite";
import {arrayAlphabeticalSort} from "../../../../../utils/helpers";

const CompanyInput = ({
    showPoolOption = false,
    showAllOption = false,
    allKey = "",
    includeInactives = false,
    optionFilter = () => {
        return true;
    },
    ...props
}) => {
    const {t} = useTranslation();
    const stores = useStore();

    return useObserver(() => (
        <React.Fragment>
            <h5>{t("fields.company", {ns: "common"})}</h5>
            <SelectField
                showSearch
                filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                    option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                data-testid="companyInput"
                {...props}
            >
                {showAllOption && (
                    <SelectField.Option value={allKey} data-testid="companySelect_option">
                        {t("filters.all", {ns: "common"})}
                    </SelectField.Option>
                )}
                {props.list
                    ? props.list?.map(company => (
                          <SelectField.Option
                              key={company}
                              value={company}
                              data-testid="companySelect_option"
                          >
                              {company}
                          </SelectField.Option>
                      ))
                    : arrayAlphabeticalSort(
                          [
                              ...stores.appStore.companyListFilter.filter(company =>
                                  includeInactives ? true : !company.disabled
                              )
                          ],
                          "companyName"
                      )
                          .filter(optionFilter)
                          .map(company => (
                              <SelectField.Option
                                  key={company._id}
                                  value={company._id}
                                  data-testid="companySelect_option"
                              >
                                  {company.companyName}
                              </SelectField.Option>
                          ))}
            </SelectField>
        </React.Fragment>
    ));
};

export default CompanyInput;
